import React, { useEffect, useMemo, useRef } from "react";
import style from "./index.module.scss";
import { useCurrentTimeSync } from "utils/useCurrentDate";
import moment from "moment";
import { useInterval } from "react-use";
import classNames from "classnames";

interface CountDownProps {
    startTime: string;
    validityTime: number; // 持续时间(分钟)
    onEnd: () => void;
    onCountDown?: () => void;
    className?: string;
}

export default function CountDown({
    startTime,
    validityTime,
    onEnd,
    onCountDown,
    className
}: CountDownProps) {
    const isEndRef = useRef(false);
    const serverTime = useCurrentTimeSync();

    useInterval(onCountDown || (() => null), 10000); // 十秒刷新数据

    const time = useMemo(() => {
        const millisecond = Math.max(serverTime.diff(moment(startTime)), 0);
        const duration = moment.duration({ millisecond });
        const sec = duration.seconds();
        const totalSec = Math.round(Math.max(duration.asSeconds(), 0));
        const label =
            totalSec > 24 * 3600
                ? "超过一天"
                : `${Math.floor(duration.asMinutes())}:${
                      sec < 10 ? `0${sec}` : sec
                  }`;
        return { label, totalSec };
    }, [serverTime, startTime]);

    // 自动终止活动
    useEffect(() => {
        if (!validityTime) return;
        if (isEndRef.current) return;

        if (time.totalSec >= validityTime * 60) {
            onEnd();
            isEndRef.current = true;
        }
    }, [time.totalSec, validityTime]);

    return (
        <span
            className={classNames(style.root, className, {
                [style.overtime]: time.label === "超过一天"
            })}>
            {time.label}
        </span>
    );
}
